import { render } from "./RedZonesLoadDropdown.vue?vue&type=template&id=0365cbee&scoped=true"
import script from "./RedZonesLoadDropdown.vue?vue&type=script&lang=js"
export * from "./RedZonesLoadDropdown.vue?vue&type=script&lang=js"

import "./RedZonesLoadDropdown.vue?vue&type=style&index=0&id=0365cbee&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1709076162/src/harpia-offshore-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0365cbee"]])

export default __exports__